import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ReponseWebService } from 'app/datastruct/Meloyi.module';
import { ServicepoolService } from 'app/services/servicepool.service';
import { GestockService } from 'app/services/gestock.service';

@Component({
  selector: 'app-impression-tpv',
  templateUrl: './impression-tpv.component.html',
  styleUrls: ['./impression-tpv.component.css']
})
export class ImpressionTPVComponent implements OnInit {

  detailsCommande = [];

  retourClientWS: ReponseWebService;

  productionId: any;

  theProduction: any;
  infosProd: any;
  autresinfos: any;
  garanties: any;
  montantdevis: any;
  prenom: any;
  nom: any;

  partners = [];
  partner: any;
  current = 0;

  shopInfo: any = null;

  getDateFormatFrench(datebi) {
    if (datebi != undefined) {
      let datebiDoug = new Date(datebi);
      let weerwi = datebiDoug.toLocaleString('fr-FR', { month: 'long' });
      let jourBi = datebiDoug.getDate();
      let anneeBi = datebiDoug.getFullYear();
      return jourBi + " " + weerwi + " " + anneeBi;
    } else
      return "";
  }

  constructor(private gestockService: GestockService, private configServer: ServicepoolService, public dialogRef: MatDialogRef<ImpressionTPVComponent>, public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.productionId = data.element;
    this.souscription = data.souscription;
    console.log(data);
    console.log(this.souscription)
    console.log("The Production ID IS");
    console.log(this.productionId);
  }
  print(): void {
    let printContents, popupWin;
    printContents = document.getElementById("printer").innerHTML;
    popupWin = window.open('', '_blank', 'left=0,top=0,height=800,width=800,innerheight=800,innerwidth=1000');
    popupWin.document.open();
    popupWin.document.write(`
          <html>
              <head>
                  <style>
                      //........Customized style.......
                      
                  </style>
              </head>
              <body onload="window.print();window.close()">${printContents}<br/><h4 style="text-align: center"></h4><br/><br/><hr/><br/><p></body>
          </html>`
    );
    popupWin.document.close();
  }

  dataImpression
  dataToPrint
  operateur

  prenomi;
  nomi;
  profession;
  adresse;
  genre;
  marque;
  type;
  immat;
  police;
  duree;
  dureeEnJour;
  souscription;
  displayDate(date, type) {
    if (type == "du") {
      return date.split("T")[0].split("-")[2] + "-" + date.split("T")[0].split("-")[1] + "-" + date.split("T")[0].split("-")[0]
    } else {
      let dd = new Date(date);
      let f = dd.setDate(dd.getDate() + parseInt(this.dureeEnJour));
      let ddd = ((new Date(f)).toJSON()).split("T", 2)[0];
      return ddd.split("T")[0].split("-")[2] + "-" + ddd.split("T")[0].split("-")[1] + "-" + ddd.split("T")[0].split("-")[0]
    }

  }
  ngOnInit(): void {
    this.dataToPrint = this.productionId
    //console.log(this.dataToPrint);
    /**
     * var data = {
      "prenom": this.prenom,
      "nom": this.nom,
      "police": this.theProduction.police,
      "dateDebut": this.theProduction.dateeffet,
      "dateFin": this.theProduction.datefin,
      "proffession": "consultant",
      "adresse": "YOff",
      "vehicule": JSON.parse(this.theProduction.infos).Genre,
      "marque": JSON.parse(this.theProduction.infos).Marque,
      "type": JSON.parse(this.theProduction.infos).Appelation,
      "matricule": JSON.parse(this.theProduction.infos).Matricule,
    	
    } ;
     */
    this.prenom = this.dataToPrint.prenomAssure + " " + this.dataToPrint.nomSouscrip;
    this.profession = "";
    this.adresse = "";
    this.genre = this.dataToPrint.genre;
    this.marque = this.dataToPrint.marque;
    this.type = this.dataToPrint.modele;
    this.immat = this.dataToPrint.immatriculation;
    this.police = this.souscription.numeroPolice;
    this.duree = this.dataToPrint.dateEffet;
    this.dureeEnJour = this.dataToPrint.dateEcheance;
    //console.log(this.prenom,this.nom, this.genre)
    //console.log(JSON.parse(sessionStorage.getItem('dataImpression')));

    this.operateur = JSON.parse(sessionStorage.getItem('currentUser'));
    //console.log(this.operateur)
    this.loadShopInfo();
  }

  loadShopInfo() {
    const samacaabiyoonwii = sessionStorage.getItem("samacaabiyoonwii");
    const agence = JSON.parse(sessionStorage.getItem("agence") || '{}');
    const idpoint = agence.idpoint;

    if (samacaabiyoonwii) {
      this.gestockService.getShopInfo(samacaabiyoonwii).then(res => {
        if (res.statutreq === 1 && res.data) {
          this.shopInfo = res.data;
        }
      });
    }
  }
  annuler() {
    this.dialogRef.close();
  }
  getDetailProdLine(idprod) {
    this.configServer.getDetailProdLine(idprod).then((retourbi) => {

      this.retourClientWS = retourbi;
      var statutrec = this.retourClientWS.statutreq;
      //console.log(this.retourClientWS)
      if (statutrec == 1) {
        this.theProduction = this.retourClientWS.data[0];
        //console.log(this.theProduction)
        this.infosProd = JSON.parse(this.theProduction.infos);
        this.autresinfos = JSON.parse(this.theProduction.autresinfos);
        this.garanties = JSON.parse(this.theProduction.garanties);
        this.montantdevis = this.theProduction.montantdevis;
        this.prenom = this.theProduction.prenom;
        this.nom = this.theProduction.nom;
        console.log(this.theProduction.infos);
      }
      else
        console.log("Failed");
    });
  }

}
